import { FooterSchema } from './Footer.styles';

export const footerStyles: FooterSchema = {
  copyrightContainer: { px: 1 },
  footer: {
    pt: 0,
    bg: 'transparent',
    bgSize: 'cover',
    bgPos: 'bottom',
    color: 'white',
  },
  stackGap: '1',
  footerBar: {
    display: 'flex',
    flexDir: ['column', null, 'row'],
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: ['center', null, 'unset'],
    '& > img': {
      h: '30px',
      ml: '-1.5',
    },
  },
  LinkText: {
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  footerLink: {
    color: 'gamma.600',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    fontSize: 'xs',
  },
  footerLinkTel: {
    color: 'gamma.600',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  footerMobile: {
    border: '2px',
    borderColor: 'white',
    borderRadius: 'lg',
    w: '130px',
    cursor: 'pointer',
    boxShadow: '0px 2px 7px rgba(0, 0, 0, 0.3)',
  },
  customFooterLink: {
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontSize: 'xs',
    color: 'gamma.600',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    h: 'unset',
    mb: '1px',
  },
  footerLinks: {
    ml: ['unset', null, 'auto'],
    pb: '0',
    alignItems: 'center',
    justifyContent: ['space-around', null, 'unset'],
    color: 'gamma.600',
    fontWeight: 'medium',
    flexDir: ['row', null, 'unset'],
    display: 'none',
    mt: ['18px', null, '0'],
    gap: '1',
  },
  footerContentContainer: {
    px: 1,
    gap: '6',
    mb: 'unset',
    bg: [null, null, 'transparent'],
    justifyContent: 'space-between',
    sx: {
      '&': {
        flexDirection: ['column-reverse', null, 'column'],
      },
    },
  },
  nav: {
    fontSize: 'xs',
    minW: [null, null, '370px'],
    mt: ['2', 'unset'],
    display: ['flex', 'grid'],
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto',
    columnGap: '10',
    rowGap: '2',
    alignItems: ['center', 'end'],
    gridTemplateAreas: `
        ". ."
      `,
    sx: {
      '> a': {
        color: 'gamma.200',
        h: 'unset',
      },
      '> button': {
        color: 'gamma.200',
        h: 'unset',
        fontSize: 'xs',
      },
    },
  },
  blurb: {
    flex: 'unset',
    fontSize: 'xs',
    textAlign: ['center', 'left'],
    color: 'gamma.200',
    width: 'unset',
    mb: '0',
    ml: [null, '0'],
    mr: [null, null, '0'],
    pr: '0',
  },
  blurbHeading: {
    ml: 'unset',
    mt: 'unset',
    color: 'whiteAlpha.700',
  },
  blurbHeadingAge: {
    color: 'gamma.200',
    borderColor: 'blackAlpha.50',
    border: '2px',
    pl: '3px',
    mb: '2',
    boxSize: '8',
    fontSize: 'sm',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
  },
  blurbHeadingThink: {
    color: 'gamma.200',
    fontSize: 'xs',
    fontWeight: 'bold',
    mb: '3',
  },
  blurbContent: {
    ml: 'unset',
    px: ['2', null, '0'],
    fontSize: ['xs', null, null, 'xs'],
    lineHeight: 'tall',
  },
  copyright: {
    color: 'gamma.200',
    textAlign: ['center', 'left'],
    mb: ['2', 'unset'],
    px: ['8', 'unset'],
    py: '0',
    fontWeight: ['semibold', 'medium'],
  },
  container: {
    bg: 'transparent',
    gap: '2',
    display: 'flex',
    flexDir: 'column',
    sx: {
      '&': {
        px: 'unset',
      },
    },
    mt: '6',
  },
  footerLinkService: {
    color: 'gamma.600',
  },
  emailUs: {
    px: 1,
    fontSize: 'xs',
    fontWeight: 'bold',
    color: 'gamma.200',
    mb: '0',
    mt: ['3', null, '4'],
  },
  quickLinks: {
    textAlign: ['center', 'left'],
    color: 'gamma.600',
    textTransform: 'uppercase',
    fontSize: 'md',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    pb: '0.5',
  },
  weAcceptBox: {
    mb: '0',
  },
  weAccept: {
    color: 'gamma.600',
    textTransform: 'uppercase',
    fontSize: 'md',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    pb: '1',
  },
  imageWrapper: {
    gap: '0',
  },
  partnerWrapper: {
    mr: '1',
    boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.30)',
  },
  ourPartners: {
    color: 'gamma.600',
    textTransform: 'uppercase',
    fontSize: 'md',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    pb: '1',
  },
  footerDownloadImage: {
    borderRadius: 'md',
    border: 'none',
    boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.30)',
  },
};
